<template>
  <!-- La pagina propone tutti i files che l'utente ha caricato nel tempo -->
  <!-- divisi per acquisto. -->
  <div>
    <PageTagline :elements="tagline_elem"/>

    <!-- Tutorial contestuale per gli argomenti del form. Vengono passati gli slug name dei video da mostrare -->
    <TutorialContestuale :video_to_show="['area_assistenza']"/>

    <!-- Overlay di caricamento -->
    <CustomOverlay :show="overlay_show" text="Caricamento in corso, attendere...">

      <!-- CARD DI CONTENIMENTO DELLA PAGINA -->
      <b-card no-body class="mr-1 ml-1">
        <b-card-header>
          <h5><b-icon icon="files" class="mr-1"></b-icon> I Miei Files</h5>
        </b-card-header>
        <b-card-body>
          <!-- GRUPPO DI SELECT PER IL FILTRAGGIO DEGLI ELEMENTI -->
          <b-row class="mb-1">
            <b-col>
              <p class="font-italic font-weight-bold">Seleziona almeno un valore se vuoi filtrare i files visualizzati:</p>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <!-- Filtro per id acquisto -->
            <b-col md="3">
              <b-form-group id="group-filtro-id-acq"
                label="Id Pratica Welfare"
                label-for="filtro-id-acq"
              >
                <b-form-select id="filtro-id-acq"
                  v-model="filtro_id_acq_sel"
                  :options="filtro_id_acq"
                  @change="filtra_elementi">
                  </b-form-select>
              </b-form-group>
            </b-col>
            <!-- Filtro per categoria di acquisto -->
            <b-col md="3">
              <b-form-group id="group-filtro-acq-categ"
                label="Categoria Acquisto"
                label-for="filtro-acq-categ"
              >
                <b-form-select id="filtro-acq-categ"
                  v-model="filtro_acq_categ_sel"
                  :options="filtro_acq_categ"
                  @change="filtra_elementi">
                  </b-form-select>
              </b-form-group>
            </b-col>
            <!-- Filtro per tipologia di files -->
            <b-col md="3">
              <b-form-group id="group-filtro-tipo-file"
                label="Tipo File"
                label-for="filtro-tipo-file"
              >
                <b-form-select id="filtro_tipo_file"
                  v-model="filtro_tipo_file_sel"
                  :options="filtro_tipo_file"
                  @change="filtra_elementi">
                  </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-button class="filter-reset-btn"
                        variant="primary"
                        @click="resetta_filtri_impostati"
                        :disabled="reset_button_disabled">
                        Resetta selezioni</b-button>
            </b-col>
          </b-row>

          <!-- LISTA DEGLI ACQUISTI -->
          <!-- Per ogni riga ( cioè ogni acquisto ) impieghiamo una card -->
          <b-card class="mb-2" no-body v-for="(elem, index) in files_by_acq" :key="index">
            <b-card-header>
              <h6>Id Acquisto: <span class="font-italic font-weight-normal">{{elem.id}}</span></h6>
              <h6>Oggetto: <span class="font-italic font-weight-normal">{{elem.oggetto}}</span></h6>
            </b-card-header>
            <b-card-body>
              <!-- Aggiungiamo una b-row nel body della card all'interno del quale posizioniamo tante b-col -->
              <!-- quanti sono i files associati all'acquisto  -->
              <b-row>
                <b-col sm v-for="(file, index) in elem.files" :key="index">
                  <b-card no-body class="mx-auto mt-2" style="max-width:200px;">
                    <b-card-title class="mr-1 ml-1 mt-1 pt-2 text-center" style="font-size:1em">
                      <p>{{file.nome_file}}</p>
                    </b-card-title>
                    <b-card-body class="pr-1 pl-1 pt-1 pb-1">
                      <b-card-img :src="file.base64_thumb" alt="Image" class="rounded-0"></b-card-img>
                      <b-card-text class="mt-2 mb-2 text-center">
                        <p><em><small>{{file.tipo_file}}</small></em></p>
                        <b-button @click="scarica_documento(file.id_resource, index)" size='sm' variant='primary' ref="docs">
                          <b-icon icon="cloud-download" class="mr-1"></b-icon>Scarica il file
                        </b-button>
                      </b-card-text>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
          <!-- END - Riga Acquisto -->
        </b-card-body>
      </b-card>
    </CustomOverlay>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import CustomOverlay from '@/components/CustomOverlay'
import TutorialContestuale from '@/components/TutorialContestuale'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'
import fileDownload from 'js-file-download'

export default {
  name: 'FilesDash',
  data () {
    return {
      // Variabili generali
      tagline_elem : [ { text : "I Miei Files", link : 'site-archivio-files' } ],
      overlay_show : false,

      // I files divisi per id acquisto.
      files_by_acq : [],

      // Opzioni filtro per tipo file e valore selezionato
      filtro_tipo_file : [],
      filtro_tipo_file_sel : null,

      // Opzioni filtro per tipo categoria di acquisto e valore selezionato
      filtro_acq_categ : [],
      filtro_acq_categ_sel : null,

      // Opzioni filtro per id acquisto e valore selezionato
      filtro_id_acq : [],
      filtro_id_acq_sel : null
    }
  },
  computed : {
    /**
     * Verifica lo stato di disabilitazione del pulsante di reset dei filtri
     * in base al settaggio dei filtri stessi.
     * Se almeno un filtro è settato il pulsante è abilitato.
     */
    reset_button_disabled : function () {
      if ( this.filtro_tipo_file_sel === null && this.filtro_acq_categ_sel === null && this.filtro_id_acq_sel == null ) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    /**
     * Dato il set dati iniziale riempiamo la select del filtro per tipo file
     * con tutti i tipi di files usati da questo utente.
     */
    inizializza_filtro_tipo_file : function () {

      // Un array di lavoro solo per vedere se il tipo di file lo abbiamo
      // già incluso.
      let id_tipo = new Array();

      // Resettiamo l'array e la ripopoliamo
      this.filtro_tipo_file = new Array();

      for ( let acq of this.files_by_acq ) {
        for ( let file of acq.files ) {
          if ( ! id_tipo.includes( file.id_tipo_file ) ) {
            id_tipo.push( file.id_tipo_file );
            this.filtro_tipo_file.push( { value : file.id_tipo_file, text: file.tipo_file } );
          }
        }
      }

      // Ordiniamo gli elementi per il testo nel tipo di files
      this.filtro_tipo_file.sort ( function ( a, b ) {
        if ( a.text < b.text ) return -1;
        if ( a.text > b.text ) return 1;
        return 0;
      });

      // Aggiungiamo in testa l'opzione fissa che invita a selezionare una tipologia
      this.filtro_tipo_file.unshift( { value: null, text: "Seleziona una tipologia", disabled: true } );

    },
    /**
     * Dato il set dati iniziale riempiamo la select del filtro per categoria dell'acquisto
     * con tutte le categorie di acquisto effettuate dall'utente.
     */
    inizializza_filtro_acq_categoria : function () {

      // Un array di lavoro per vedere se la categoria che stiamo controllando
      // è già stata inclusa
      let id_categ = new Array();

      // Resettiamo l'array e la ripopoliamo
      this.filtro_acq_categ = new Array();

      for ( let acq of this.files_by_acq ) {
        for ( let file of acq.files ) {
          if ( ! id_categ.includes( file.id_categ ) ) {
            id_categ.push( file.id_categ );
            this.filtro_acq_categ.push( { value : file.id_categ, text: acq.oggetto } );
          }
        }
      }

      // Ordiniamo gli elementi per il testo nel tipo di files
      this.filtro_acq_categ.sort ( function ( a, b ) {
        if ( a.text < b.text ) return -1;
        if ( a.text > b.text ) return 1;
        return 0;
      });

      // Aggiungiamo in testa l'opzione che invita a selezionare la categoria
      this.filtro_acq_categ.unshift( { value: null, text: "Seleziona una categoria", disabled: true } );

    },
    /**
     * Dato il set dati iniziale riempiamo la select del filtro per id acquisto
     * con gli id degli acquisti di questo utente.
     */
    inizializza_filtro_id_acquisto : function () {

      this.filtro_id_acq = new Array();

      for ( let acq of this.files_by_acq ) {
        let select_text = '[' + acq.id + '] ' + acq.oggetto;
        this.filtro_id_acq.push( { value : acq.id, text: select_text } );
      }

      // Ordiniamo gli elementi per id acquisto dal più nuovo
      // al più vecchio.
      this.filtro_id_acq.sort ( function ( a, b ) {
        if ( a.value > b.value ) return -1;
        if ( a.value < b.value ) return 1;
        return 0;
      });

      // Aggiungiamo in testa l'opzione fissa che invita a seleziona la pratica.
      this.filtro_id_acq.unshift( { value: null, text: "Seleziona un una pratica", disabled: true } );

    },
    /**
     * Resetta eventuali filtri impostati ed aggiorna la schermata
     * richiamando la funzione di filtraggio
     */
    resetta_filtri_impostati : function () {
      this.filtro_tipo_file_sel = null;
      this.filtro_acq_categ_sel = null;
      this.filtro_id_acq_sel = null;
      this.filtra_elementi();
    },
    /**
     * Filtra i files in base al filtro impostato
     */
    filtra_elementi : function () {

      let params = {}

      // Sistemiamo prima i parametri della get
      if ( this.filtro_tipo_file_sel != null ) {
        params.id_tipo_file = this.filtro_tipo_file_sel;
      }
      if ( this.filtro_acq_categ_sel != null ) {
        params.id_categoria = this.filtro_acq_categ_sel;
      }
      if ( this.filtro_id_acq_sel != null ) {
        params.id_ordine = this.filtro_id_acq_sel;
      }

      this.carica_elementi( params );

    },
    /**
     * Chiama il backend per caricare i dati da visualizzare
     *
     * - params: eventuali parametri da inviare in get per filtrare i risultati
     *           si tratta di un oggetto con le seguenti chiavi ( tutte opzionali )
     *            - id_tipo_file : filtro per tipologia di files
     *            - id_categoria : filtro per categoria di acquisto welfare
     *            - id_ordine    : filtro per id ordine
     */
    carica_elementi : function ( params = {} ) {

      this.overlay_show = true;

      axios.get( apiUrl.documentsapi.get_user_document_list, { params: params } )
      .then( (response) => {
        this.files_by_acq = response.data;
        this.inizializza_filtro_tipo_file();
        this.inizializza_filtro_acq_categoria();
        this.inizializza_filtro_id_acquisto();
        this.overlay_show = false;
      })
      .catch( (error) => {
          this.overlay_show = false;
          generalLib.backend_error_message_box( this, error.response.data );
      });
    },
    /**
     * Scarica il documento richiesto
     *
     * - id_resource - L'id del documento da scaricare.
     * - index - L'indice che identifica il pulsante premuto.
     */
    scarica_documento : function ( id_resource, index ) {

      // Disabilitiamo il pulsante sul quale l'utente ha premuto
      // sino a fine richiesta ( fa capo alla ref docs definita per i pulsanti )
      this.$refs.docs[index].disabled = true;

      let call_api = apiUrl.documentsapi.download_document.replace( '@id_resource', id_resource );

      // Dobbiamo specificare ad axios che i dati che riceverà saranno
      // di tipo blob ( binary ) altrimenti il file scaricato risulterà
      // corrotto.
      axios.get( call_api, { responseType: 'blob' }  )
      .then( ( response ) => {
        this.$refs.docs[index].disabled = false;
        // Prendiamo il nome dall'header content-disposition
        let nome_file = generalLib.get_nome_file( response );
        // Usiamo js-file-donwload per salvare il file sul client
        fileDownload( response.data, nome_file );
      })
      .catch( (error) => {
        this.$refs.docs[index].disabled = false;
        generalLib.backend_error_message_box( this, error.response.data );
      });
    }
  },
  /**
   * Alla creazione della vista chiamiamo il backend per avere i files dell'utente.
   */
  created : function () {
    this.carica_elementi();
  },
  components : {
    PageTagline,
    CustomOverlay,
    TutorialContestuale
  }
}
</script>

<style scoped>
/* Stile per il bottone di reset dei filtri */
.filter-reset-btn {
  margin-top: 2em;
}

@media (max-width: 768px) {
  .filter-reset-btn {
    margin-top: 0px;
  }
}
</style>